import { render, staticRenderFns } from "./SidBackgroundMask.vue?vue&type=template&id=7ba8d0c0&scoped=true"
import script from "./SidBackgroundMask.vue?vue&type=script&lang=js"
export * from "./SidBackgroundMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8d0c0",
  null
  
)

export default component.exports